export default __webpack_public_path__ + "static/media/logo-plurall-unsmile.3593207c.svg";